/*
 * @Author: zhangsheng
 * @Date: 2023-09-18 08:55:47
 * @LastEditors: duyuanyuan
 * @LastEditTime: 2023-09-28 16:15:59
 * @FilePath: \panda-index-sicermem-frontend\src\locales\zh-CN\coreTechnology.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
export default {
  'CoreTechnology.index.486489-0': '耐酸碱、氧化等化学性危害',
  'CoreTechnology.index.486489-1': '耐有机溶剂、油脂污染',
  'CoreTechnology.index.486489-2': '耐悬浮物、浊度等污染',
  'CoreTechnology.index.486489-3': '耐高温',
  'CoreTechnology.index.486489-4': '机械强度高',
  'CoreTechnology.index.486489-5': '环保、再生性好',
  'CoreTechnology.index.486489-6': '通量高',
  'CoreTechnology.index.486489-7': '是有机膜的3~4倍',
  'CoreTechnology.index.486489-8': '占地面积小',
  'CoreTechnology.index.486489-9': '成本低',
  'CoreTechnology.index.486489-10': '自有技术与生产',
  'CoreTechnology.index.486489-11': '寿命长',
  'CoreTechnology.index.486489-12': '生命周期成本低',
  'CoreTechnology.index.486489-13': '产水水质好',
  'CoreTechnology.index.486489-14': '无机膜孔径分布均一性好',
  'CoreTechnology.index.486489-15': '能耗低',
  'CoreTechnology.index.486489-16': '节能，跨膜压差小',
  'CoreTechnology.index.486489-17': '是有机膜的1/2~1/3',
  'CoreTechnology.index.486489-18': '膜面积增加2倍',
  'CoreTechnology.index.486489-19': '熊猫W无机膜相比常规平板膜，在相近的装填密度的情况下，将膜面积增加到2倍',
  'CoreTechnology.index.486489-20': '反洗更高效，更彻底',
  'CoreTechnology.index.486489-21': 'W无机膜的内通道为菱形结构，膜的厚度在每个点上都是相等的，反洗更高效，更彻底',
  'CoreTechnology.index.486489-22': '纯水通量达1.5~2倍',
  'CoreTechnology.index.486489-23':
    'W无机膜的支撑体为氧化铝，膜层可为氧化铝，氧化锆，碳化硅等多种材料，熊猫正在研发的碳化硅膜层的亲水性大幅优于氧化铝，碳化硅膜层的纯水通量为氧化铝膜层的1.5~3倍',
  'CoreTechnology.index.486489-24': '抗折强度高20%~30%',
  'CoreTechnology.index.486489-25': 'W无机膜纵向抗折强度高于常规平板陶瓷膜20%~30%',
  'CoreTechnology.index.486489-26': '信息查询',
  'CoreTechnology.index.486489-27': 'W无机膜',
  'CoreTechnology.index.486489-28': '对比传统有机膜',
  'CoreTechnology.index.486489-29': '对比常规平板陶瓷膜',
  'CoreTechnology.index.486489-30': '/coreTechnology',
};
